import React from 'react'
import PropTypes from 'prop-types'

import Message from './Message'
import ResultContainer from './ResultContainer'
import ButtonNavigation from './ButtonNavigation'
import ContainerFAQ from './ContainerFAQ'
import Messengers from './Messengers'
import IframeBlock from './IframeBlock'
import FileContainer from './FileContainer'
import Notification from './Notification'

import { ReactComponent as IconLoader } from '../assets/images/loader-download-file.svg'

const Content = ({
  arrMessage,
  handleChangeFAQ,
  navigationButton,
  handleNavigation,
  myRef,
  handleResultAsked,
  handleClickMessanger,
  scrollContainer,
  refScroll,
  pathname,
  useNodeRed,
  widgetId,
  babyToken,
  dialogId,
  showImage,
  paramsApp,
  buttonLoadingHistory,
  clickSendMeesageToWorkerGetHistory,
  notification
}) => {

  return (
    <div className="container">
      {<div className={`scroll-container ${navigationButton && 'withNavigation'}`} 
      onScroll={scrollContainer}
      ref={refScroll}
      >
        <div className={`content`} 
        ref={myRef}
        >
          {/* {notification.show && (
            <Notification text={notification.text}>
              {!!useNodeRed && buttonLoadingHistory.show && <button className='button-history' onClick={clickSendMeesageToWorkerGetHistory}>Завантажити історію</button>}
            </Notification>
          )} */}
          {/* {!!useNodeRed && buttonLoadingHistory.show && !notification.show &&  (
            <button className='button-history' onClick={clickSendMeesageToWorkerGetHistory}>Завантажити історію</button>
          )} */}
          {/* {!!useNodeRed && buttonLoadingHistory.isLoading && <span className='loading-history'><IconLoader /></span>}  */}
          {useNodeRed ? arrMessage.map((message, index) => {
            switch (message.blockType) {
              case 3: 
                return <Message title={message.title} message={message.text} key={message.id}/>
              case 5: 
                return <Message message={message.text} key={message.id} type='client_message' time={message.timeMessage}/>
              case 6: 
                return <Message message={message.text} key={message.id} time={message.timeMessage}/>
              case 2: 
                return <Message title={message.title} message={message.text} key={index}/>
              case 4: 
                return <ResultContainer
                  key={message.id}
                  rating={message.rating}
                  id={message.id}
                  idFaq={message.idFaq}
                  handleResultAsked={handleResultAsked}
                />
              case 8: 
                return <Message  key={message.id} type={message.typeMessage} message={message.text} />
              case 9: 
                return <IframeBlock
                  id={message.id}
                  key={message.id}
                  url={message.text}
                  rootURL={pathname}
                  heightFrame={message.heightFrame}
                  widgetId={widgetId}
                  babyToken={babyToken}
                  dialogId={dialogId}
                  paramsApp={paramsApp}
                />
                case 10: 
                  return <FileContainer showImage={showImage} paramsApp={paramsApp} {...message}/>
              default:
                return null
            }
          }) : 
          arrMessage.map((message, index) => {
            switch (message.blockType) {
              case 1:
              case 2:
                return <ContainerFAQ
                  key={message.id + index}
                  title={message.title}
                  arrFaq={message.variable}
                  idGroup={message.id}
                  handleChangeFAQ={handleChangeFAQ}
                  />
              case 3: 
                return <Message title={message.title} message={message.text} key={message.id + index}/>
              case 5: 
                return <Message message={message.text} key={message.id + index} type='client_message'/>
              case 6: 
                return <Message message={message.text} key={message.id + index}/>
              // case 2: 
              //   return <Message title={message.title} message={message.text} key={index}/>
            /*   case 3: 
                return */
              case 4: 
                return <ResultContainer
                  key={message.id + index}
                  rating={message.rating}
                  id={message.id}
                  idFaq={message.idFaq}
                  handleResultAsked={handleResultAsked}
                />
              case 8: 
                return <Message  key={message.id + index} type={message.typeMessage} message={message.text} />
              case 7: 
                return <Messengers  key={message.id + index} handleClickMessanger={handleClickMessanger}/>
              case 9: 
                return <IframeBlock
                  id={message.id}
                  key={message.id + index}
                  url={message.text}
                  rootURL={pathname}
                  heightFrame={message.heightFrame}
                  babyToken={babyToken}
                  dialogId={dialogId}
                  paramsApp={paramsApp}
                />
              default:
                return null
            }
          })}
        </div>
         {navigationButton && !useNodeRed && <ButtonNavigation navigationButton={navigationButton} handleNavigation={handleNavigation}/>}
      </div>}
    </div>
  )
}

Content.propTypes = {
  arrMessage: PropTypes.array.isRequired,
  handleChangeFAQ: PropTypes.func.isRequired,
  handleClickMessanger: PropTypes.func.isRequired,
  handleNavigation: PropTypes.func.isRequired,
  handleResultAsked: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired,
  refScroll: PropTypes.object.isRequired,
  scrollContainer: PropTypes.func.isRequired,
  showNavigation: PropTypes.bool.isRequired,
  navigationButton: PropTypes.bool,
  useNodeRed: PropTypes.bool.isRequired,
  widgetId: PropTypes.string.isRequired,
  babyToken: PropTypes.string.isRequired,
  myRef: PropTypes.any,
  dialogId: PropTypes.string,
  showImage: PropTypes.func,
  paramsApp: PropTypes.object,
  buttonLoadingHistory: PropTypes.shape({
    show: PropTypes.bool,
    isLoading: PropTypes.bool
  }),
  notification: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  })
}

export default Content